// import { askNotificationPermission } from "@/utilities";
import mixins from 'vue-typed-mixins';
import { pwaUpdateAppMixin } from './mixins';
import { Icon, Modal, Banner } from '@/components';
import { featureToggleMixin } from '@/mixins';
const Navbar = () => import('@/components/composite/Navbar.vue');
const Footer = () => import('@/components/composite/Footer.vue');
export default mixins(featureToggleMixin).extend({
    name: 'App',
    mixins: [pwaUpdateAppMixin],
    components: {
        Navbar,
        Modal,
        Icon,
        Footer,
        Banner,
    },
    metaInfo: {
        title: 'Akun Pembelajaran | Kemdikbudristek',
        meta: [
            {
                vmid: 'description',
                name: 'description',
                content: 'Akun Pembelajaran merupakan akun elektronik yang diterbitkan oleh Kementerian Pendidikan dan Kebudayaan.',
            },
        ],
    },
    computed: {
        isAccountLookupPage() {
            return this.$route.name === 'account-lookup';
        },
    },
    data: () => ({
        hasAnnouncement: false,
        announcementMessage: ``,
    }),
    watch: {
        hasAnnouncement: {
            immediate: true,
            handler(val) {
                if (val) {
                    document.body.classList.add('has-announcement');
                }
                else {
                    document.body.classList.remove('has-announcement');
                }
            },
        },
        'TOGGLES.testAnnouncementBar': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.hasAnnouncement = true;
                    this.announcementMessage =
                        'This is announcement message for testing purpose only';
                }
            },
        },
    },
    mounted() {
        // disable ask permission for now
        // askNotificationPermission();
    },
});
